import { render, staticRenderFns } from "./infoView.vue?vue&type=template&id=483447de&scoped=true"
import script from "./infoView.vue?vue&type=script&lang=js"
export * from "./infoView.vue?vue&type=script&lang=js"
import style0 from "./infoView.vue?vue&type=style&index=0&id=483447de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483447de",
  null
  
)

export default component.exports